import { adminApiClient } from './adminApiClient';
import { createNestedCrudService } from './createCrudService';
import type { WorkflowStep } from './workflowDefinitionsService';

// Re-export for convenience
export type { WorkflowStep } from './workflowDefinitionsService';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface StoreWorkflowStepRequest {
  step_type: string;
  name: string;
  sort_order: number;
  execution_mode?: 'sync' | 'async';
  config?: Record<string, unknown> | null;
  condition?: Record<string, unknown> | null;
  is_active?: boolean;
  timeout_seconds?: number | null;
  retry_policy?: Record<string, unknown> | null;
}

export interface UpdateWorkflowStepRequest {
  step_type?: string;
  name?: string;
  sort_order?: number;
  execution_mode?: 'sync' | 'async';
  config?: Record<string, unknown> | null;
  condition?: Record<string, unknown> | null;
  is_active?: boolean;
  timeout_seconds?: number | null;
  retry_policy?: Record<string, unknown> | null;
}

// ---------------------------------------------------------------------------
// Service
// ---------------------------------------------------------------------------

const buildBasePath = (workflowSlug: string) =>
  `/admin/workflows/${workflowSlug}/steps`;

const crudService = createNestedCrudService<
  WorkflowStep,
  StoreWorkflowStepRequest,
  UpdateWorkflowStepRequest
>(buildBasePath);

export const workflowStepsService = {
  ...crudService,

  async getStepTypes(): Promise<{ data: string[] }> {
    const response = await adminApiClient.get<{ data: string[] }>('/admin/workflows/step-types');
    return response.data;
  },

  async reorder(
    workflowSlug: string,
    steps: Array<{ id: string; sort_order: number }>,
  ): Promise<void> {
    await adminApiClient.patch(
      `${buildBasePath(workflowSlug)}/reorder`,
      { steps },
    );
  },
};
